<template>
	<app>
		<div class="company-info">
			<div class="flex-column flex-center">
				<strong>{{detailInfo.bf_money}}元</strong>
				<b>保费金额</b>
			</div>
			<div>
				<p>收款账号：{{insuranceInfo.bank_code}}</p>
				<p>户名：{{insuranceInfo.account_name}}</p>
				<p>开户行：{{insuranceInfo.bank_name}}</p>
			</div>
		</div>
		
		<div class="upload">
			<c-upload-file v-model="voucher" type="image" media="image" button="上传付款凭证"></c-upload-file>
		</div>
		
		<c-title>开票信息</c-title>
		<c-form ref="form" unit-width="400" style="padding-top: 0;">
			<c-form-item v-model="currentInvoiceType" type="radio" label="发票类型" name="fp_type" required :options="invoiceType"></c-form-item>
			<div v-show="currentInvoiceType != 3">
				<c-form-item type="input" label="发票抬头" name="fp_title" required></c-form-item>
				<c-form-item type="input" label="纳税识别号" name="fp_nsrsbh" required></c-form-item>
				<c-form-item type="input" label="开户银行" name="fp_bank" required></c-form-item>
				<c-form-item type="input" label="银行账号" name="fp_account" required></c-form-item>
				<c-form-item type="input" label="收票联系人" name="fp_lxr"></c-form-item>
				<c-form-item type="input" label="收票地址" name="fp_address"></c-form-item>
				<c-form-item type="input" label="联系电话" name="fp_lxdh"></c-form-item>
				<c-form-item type="input" label="电子邮箱" name="fp_email" required></c-form-item>
			</div>
		</c-form>
		
		<div slot="button">
			<c-button size="m" @click="submitHandle">确认并提交</c-button>
		</div>
	</app>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		props: {
			id: String
		},
		
		data() {
			return {
				detailInfo: {},
				insuranceInfo: {},
				voucher: '',
				currentInvoiceType: ''
			}
		},
		
		computed: {
			...mapState(['invoiceType'])
		},
		
		mounted() {
			this.request({
				url: '/project/bx/detail',
				data: {
					bx_id: this.id
				},
				loading: true,
				success: data => {
					this.detailInfo = data.bxInfo;
					this.insuranceInfo = data.bxgsInfo;
				}
			});
			this.request({
				url: '/project/bx/lastBxFp',
				success: data => {
					this.$refs.form.set(data);
				}
			});
		},
		
		methods: {
			submitHandle() {
				if (!this.voucher) {
					this.$message({
						text: '请上传付款凭证'
					});
					return;
				}
				
				this.$refs.form.submit({
					url: '/project/bx/updateBxfp',
					rule: this.currentInvoiceType == 3 ? {} : {
						fp_type: '请选择发票类型',
						fp_title: '请填写发票抬头',
						fp_nsrsbh: '请填写纳税识别号',
						fp_bank: '请填写开户行',
						fp_account: '请填写账号',
						fp_email: '请填写电子邮箱'
					},
					dataFormatter: data => {
						data.bx_id = this.id;
						data.fp_fk_path = this.voucher;
						return data;
					},
					
					success: () => {
						this.$message({
							text: '提交成功'
						});
						this.navigateBack();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.company-info {
		padding: .3rem .24rem;
		background: #F1F8FE;
		
		strong {
			font-size: .6rem;
			color: #f00;
		}
		
		b {
			margin: .2rem 0 .3rem;
			font-size: .32rem;
			color: #000;
		}
		
		p {
			text-align: center;
			line-height: .52rem;
			font-size: .28rem;
			color: #444;
		}
	}
	
	.upload {
		padding: .24rem .4rem;
		background: #fff;
	}
</style>
